<template>
    <ContainerWithMenu>
        <div class="page-content">
            Analytics
        </div>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";

    export default {
        name: "Analytics",
        components: { ContainerWithMenu }
    };
</script>
